import { isNil } from 'lodash';
import { DEFAULT_CALLOUT_PROPS } from '../../../../../Shape/config/Shapes';

const getTailWidth = shape => (isNil(shape.get('tailWidth')) ? DEFAULT_CALLOUT_PROPS.tailWidth : shape.get('tailWidth'));

export default getTailWidth;
